module.exports = __webpack_public_path__ + "static/media/sign-in-asset.603e833b.svg";